import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const cartPagePromise = import("./CartPage.js");
export default Auth(lazy(() => cartPagePromise));
